import pluralize from 'pluralize'
import React, { useState } from 'react'
import { useSelector } from "react-redux"
import { useHistory, useParams } from 'react-router-dom'

import Modal from "../reusable/modal"
import Receive from '../reusable/receive'
import NewInventoryItem from './newinventoryitem'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'
import InitiateReturn from "./initiateReturn"

const SingleItemRequest = ({ path = '/app/store', onPerform }) => {
    const [index, setIndex] = useState([])
    const [record, setRecord] = useState([])
    const [request, setRequest] = useState([])

    const { user } = useSelector(state => state.application)

    const [visible, toggle] = useToggle(true)
    const [rtn, toggleRtn] = useToggle()

    const { rq } = useParams()

    const history = useHistory()

    const [{ loading, error }, refresh] = usePet('viewRequest', { id: rq }, { notify: true, callback: ({ data }) => setRequest(data) })
    
    const close = () => {
        toggle()
        setTimeout(() => history.goBack(), 300)
        onPerform()
    }

    const initiateReturn = (itm, key) => {
        setIndex(key)
        setRecord(itm)
        toggleRtn()
    }

    return (
        <Modal
            w={ 600 }
            centered={ false }
            title="Request"
            toggle={close}
            visible={visible}>
            <p className="text-gray-500 text-xs italic">Requested by {request?.requestedBy?.name} on { stringifyDate(request?.date) }</p>
            <Receive
                error={error}
                loading={loading}
                progress>
                {
                    request?.requests?.length > 0 ?
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2 pl-4 text-center">
                                        <div className="font-semibold">No.</div>
                                    </th>
                                    <th className="p-2 pl-4 text-left">
                                        <div className="font-semibold">Item</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Requested</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold">Issued</div>
                                    </th>
                                    <th className="p-2 text-left">
                                        <div className="font-semibold"></div>
                                    </th>
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    request.requests.map((rqs, key) =>
                                        <tr>
                                            <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                            <td className="p-2 pl-4 h-5">
                                                {rqs?.item?.name}
                                                { (rqs.discarded || rqs.issued) && <p className="text-gray-500 text-xs italic">{ rqs?.discarded ? `Discarded by ${rqs?.discardedBy?.name}` : rqs.issued ? `Issued by ${rqs?.issuedBy?.name}` : '' }</p> }
                                            </td>
                                            <td className="p-2 pl-4 h-5">
                                                <span className="flex items-center">
                                                    {rqs.quantity} { pluralize(rqs?.item?.issuedIn ?? 'Units', rqs.quantity) }
                                                </span>
                                            </td>
                                            <td className="p-2 pl-4 h-5">
                                                <span className="flex items-center">
                                                    {rqs.qtyIssued ?? 0 } { pluralize(rqs?.item?.issuedIn ?? 'Units', rqs.qtyIssued ?? 0) }
                                                </span>
                                            </td>
                                            <td className="p-2 pl-4 h-5">
                                                <span className="flex items-center">
                                                    {
                                                        (rqs?.return && !rqs?.return?.discarded) ?
                                                            <div className={ rqs?.return?.returned ? 'text-green-500' : 'text-yellow-500' }>{ rqs?.return?.returned ? 'Returned' : 'Return Initiated' }</div>
                                                        : (rqs?.issued && (request.requestedBy?._id === user?._id)) ?
                                                            <button onClick={ () => initiateReturn(rqs, key) } className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Initiate Return</button>
                                                        : null
                                                    }
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        : <div className="align-center flex w-full">
                            <h2>No items have been requested</h2>
                        </div>
                }
            </Receive>
            <div className="flex justify-end">
                <button disabled={loading} onClick={close} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
            {
                rtn &&
                <InitiateReturn
                    id={ rq }
                    index={ index }
                    visible={ rtn }
                    record={ record }
                    toggle={ toggleRtn }
                    onPerform={ refresh } />
            }
        </Modal>
    )
}

export default SingleItemRequest